import * as Yup from "yup";
export default Yup.object({
  title: Yup.string().required("Topic is required"),
  videoFile: Yup.mixed().required("A video file is required"),
});
